<div class="alert-trial" *ngIf="me().role == 'trial'">
  {{translate.instant('TOOLBAR.TRIALDAYS', {days: me().trialDaysLeft})}}
  <a href="{{translate.instant('TOOLBAR.NESTAS_PRICE_LINK')}}" class="link cursor" title="{{translate.instant('TOOLBAR.NESTAS_PRICE_LINK')}}">
    <button class="">{{translate.instant('TOOLBAR.CONTACT_NESTAS')}}</button>
  </a>
</div>
<div class="alert-trial alert-impersonate" *ngIf="me().impersonate">
  {{translate.instant('TOOLBAR.IMPERSONATING', {firstname: me().firstname, lastname: me().lastname})}}
  <button (click)="stopImpersonate()" class="">{{translate.instant('TOOLBAR.STOP_IMPERSONATE')}}</button>
</div>
<mat-toolbar class="toolbar wrap">

  <mat-toolbar-row class="first-toolbar-row">
    <span class="example-fill-remaining-space"></span>

    <mat-nav-list class="nav-dropdown">

        <mat-list-item>
          <a *ngIf="isLoggedIn()" mat-list-item class="mat-list-item notification" (click)="showMenu($event, 0)">
            <div class="icon-badge-container">
              <div *ngIf="notifications.length" class="notifications">
                <i mat-18 class="material-icons bell padding">notifications_none</i>
                <div class="test" *ngIf="unseen > 0">
                  <span>{{unseen}}</span>
                </div>
              </div>
              <div #dropdownmenu class="dropdownmenu notification-menu" [class.show-notif]="show[0]">
                <div class="title">
                  {{translate.instant('TOOLBAR.NOTIFICATIONS')}}
                  <a *ngIf="notifications.length > 0" class="mark-read" (click)="seenAll()">{{translate.instant('TOOLBAR.MARK_ALL_AS_READ')}}</a>
                </div>
                <ul class="notification-list">
                  <li *ngIf="notifications.length == 0" class="no-notification-elem">
                    {{translate.instant('TOOLBAR.NO_NOTIFICATION')}}
                  </li>
                  <div *ngFor="let n of notifications" (click)="goToNotification(n)" class="notification-elem"
                    [class.unseen]="!n.seen">
                    <a>
                      <span>{{translate.instant(n.message, n.options)}}</span>
                    </a>
                  </div>
                </ul>
              </div>
            </div>
          </a>
        </mat-list-item>
    </mat-nav-list>
    <mat-nav-list>

        <mat-list-item>
        <a *ngIf="isLoggedIn()" (click)="showMenu($event, 1)" class="mat-list-item">
          <span class="btn-style">{{me().firstname}}
            <i _ngcontent-hvq-21="" class="material-icons ic-arrow-drop-down">arrow_drop_down</i>
          </span>
          <div #dropdownmenu *ngIf="show[1]" class="dropdownmenu show">
            <ul>
              <li (click)="goToStep(['profile'])">
                <i class="material-icons ic-icon">account_circle</i>&nbsp;
                <a>{{translate.instant('TOOLBAR.STEP.PROFILE')}}</a>
              </li>
              <li (click)="goToStep(['contractor'])">
                <i class="material-icons ic-icon">article</i>&nbsp;
                <a>{{translate.instant('TOOLBAR.STEP.CONTRACTORS')}}</a>
              </li>
              <li (click)="goToStep(['template'])">
                <i class="material-icons ic-icon">text_snippet</i>&nbsp;
                <a>{{translate.instant('TOOLBAR.STEP.TEMPLATE')}}</a>
              </li>
              <li (click)="goToStep(['audittrail'])">
                <i class="material-icons ic-icon">text_snippet</i>&nbsp;
                <a>{{translate.instant('TOOLBAR.STEP.AUDITTRAIL')}}</a>
              </li>
              <li *ngIf="isAdmin()" (click)="goToStep(['admin'])">
                <i class="material-icons ic-icon">settings</i>&nbsp;
                <a>{{translate.instant('TOOLBAR.ADMIN_PANEL')}}</a>
              </li>
              <li (click)="logOut()">
                <i class="material-icons ic-icon">keyboard_tab</i>&nbsp;
                <a>{{translate.instant('TOOLBAR.LOGOUT')}}</a>
              </li>
            </ul>
          </div>
        </a>
      </mat-list-item>
    </mat-nav-list>
    <mat-nav-list>

      <mat-list-item>
        <a (click)="showMenu($event, 2)" class="mat-list-item">
          <span class="btn-style lite" style="padding: 12px 10px 12px 14px;">
            <i class="material-icons lang-ic" style="font-size: 18px;margin-right:3px">language</i>
            <span>{{translate.currentLang}}</span>
            <i _ngcontent-hvq-21="" style="margin-left:3px" class="material-icons ic-arrow-drop-down-lang">arrow_drop_down</i>
          </span>
          <div #dropdownmenu class="dropdownmenu" [class.showThin]="show[2]">
            <ul>
              <li>
                <nestas-lang></nestas-lang>
              </li>
            </ul>
          </div>
        </a>
      </mat-list-item>

    </mat-nav-list>
  </mat-toolbar-row>

  <mat-toolbar-row class="second-toolbar-row">
    <a (click)="goToStep([''])" class="logo">
      <img src="/assets/NestasLogoHeader.png" alt="Nestas Logo" />
    </a>
  </mat-toolbar-row>
  
</mat-toolbar>